// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Fmhj","header":"MessagesList_header__2r6FI","chat":"MessagesList_chat__QvepO"};